export const complaints = '/complaints';
export const complaint = (id: number) => `/complaints/${id}`;
export const download = '/complaints/download';
